function Dipespeticaintegridad() {
        return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Ética, Integridad y Responsabilidad 
                    del Funcionario Público brinda formación teórica y práctica sobre 
                    principios éticos y normas de conducta en el sector público.
               </p>
               <p>
                    El programa aborda contenidos relacionados con ética pública, 
                    prevención de conflictos de interés, responsabilidad administrativa 
                    y promoción de buenas prácticas institucionales.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias éticas y profesionales para ejercer 
                            funciones públicas con integridad, responsabilidad y transparencia.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img src='/uploads/curs_habilidades_blandas.jpg' alt='logo-de-metodologia' className='logo-metodologia'/>
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 913376365 / 948251685</p>
                        <p>📧 esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Ética Pública </li>
                    <li> 2. Integridad en la Función Pública </li>
                    <li> 3. Conflictos de Interés </li>
                    <li> 4. Transparencia y Rendición de Cuentas </li>
                    <li> 5. Buenas Prácticas Institucionales </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespeticaintegridad
